import React, { useState, useEffect } from "react";
import { authActions } from "../../store/actions/auth.actions";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import { FormControl, FormHelperText } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import LoginPageStyle from "../../styles/LoginPageStyle";
import LoginBanner from "../../components/loginBanner";
import MessagePanel from "../../components/messagePanel";
import { IDRaksStore } from "../../store/store";
import { AccountActionsState } from "../../store/types/auth";

interface ResetHaslaInitProps {
  onInitResetPassword: Function;
  error: string;
  onClearError: Function;
  onClearAccountActionsState: Function;
  accountActionsState: AccountActionsState;
}

export const ResetHaslaInitPage = (props: ResetHaslaInitProps) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const { onClearError, onClearAccountActionsState } = props;

  useEffect(() => {
    return () => {
      onClearError();
      onClearAccountActionsState();
    };
    // eslint-disable-next-line
  }, []);

  function handleSubmit(e: React.FormEvent<HTMLElement>) {
    e.preventDefault();
    onClearError();
    setEmailError(!email ? "Pole wymagane" : "");
    if (email) {
      props.onInitResetPassword(email);
    }
  }

  return (
    <>
      <LoginPageStyle>
        <div className="loginContainer">
          <div className="loginContainer__error">
            {props.error && (
              <MessagePanel title="Błąd!" mode="error" message={props.error} />
            )}
          </div>

          {props.accountActionsState ===
          AccountActionsState.ResetPswdMailSent ? (
            <div className="loginContainer__info">
              <div className="loginContainer__info__primarytext">
                <h5 className="light">Na adres</h5>
                <h5 className="light">{email} </h5>
                <h5 className="light">wysłaliśmy e-mail z linkiem</h5>
                <h5 className="light">do zmiany hasła.</h5>
              </div>
              <div className="loginContainer__info__primarytext">
                <div className="light subtitle1">
                  Odbierz pocztę i kliknij przesłany link.
                </div>
              </div>
              <div className="loginContainer__info__secondarytext">
                <div className="light body2">
                  Jeżeli nie otrzymałeś wiadomości, sprawdź folder SPAM
                </div>
                <div className="light body2">
                  lub dodaj adres no-reply@raks.pl do książki adresowej.
                </div>
              </div>
              <div className="loginContainer__info__additionaloption light subtitle1">
                Wróć na ekran{" "}
                <Link to="/login" className="link">
                  logowania
                </Link>
              </div>
            </div>
          ) : (
            <div className="loginContainer__main">
              <div className="loginContainer__main__window">
                <h4 className="loginContainer__main__window__header">
                  Odzyskaj hasło
                </h4>
                <form onSubmit={handleSubmit}>
                  <FormControl error={emailError !== ""}>
                    <TextField
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      label="Adres e-mail"
                    />
                    {emailError && (
                      <FormHelperText id="email-error-text">
                        {emailError}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <div className="loginContainer__main__window_signupbutton">
                    <Button type="submit" variant="contained" color="secondary">
                      DALEJ
                    </Button>
                  </div>
                </form>
              </div>
              <div className="loginContainer__main__additionaloption light subtitle2">
                Wróć na ekran{" "}
                <Link to="/login" className="link">
                  logowania
                </Link>
              </div>
            </div>
          )}

          <div className="light subtitle1 loginContainer__footer"></div>
        </div>
        <LoginBanner />
      </LoginPageStyle>
    </>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.auth.error,
    accountActionsState: store.auth.accountActionsState,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onInitResetPassword: (email: string) =>
      dispatch(authActions.resetPasswordSendEmail(email)),
    onClearAccountActionsState: () => {
      dispatch(authActions.clearAccountActionsState());
    },
    onClearError: () => {
      dispatch(authActions.clearError());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetHaslaInitPage);
